"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathFill = exports.activepie = exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "esjpkup0"
} : {
  target: "esjpkup0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "t3g4jm",
  styles: "display:flex;height:233px;width:233px;svg{height:100%;}svg path,svg text{cursor:pointer;}"
} : {
  name: "t3g4jm",
  styles: "display:flex;height:233px;width:233px;svg{height:100%;}svg path,svg text{cursor:pointer;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const pathFill = theme => /*#__PURE__*/(0, _react.css)("fill:", theme.illustrationPrimary10, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:pathFill;"));
exports.pathFill = pathFill;
const activepie = theme => /*#__PURE__*/(0, _react.css)("fill:", theme.illustrationPrimary40, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:activepie;"));
exports.activepie = activepie;